<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-show="!loading">
                    <data-table :headings="deliveryOrderHeadings" :data="orders" :hasActions="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                :fieldToDetermineColumnColor="stillPendingAfterAllottedTimeFieldName"
                                @pagingUpdated="onPagingUpdated"
                                @actionClicked="onOrderActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100">
                                <div class="dropdown">
                                    <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMen1" data-toggle="dropdown" data-boundary="viewport" aria-haspopup="true" aria-expanded="false">
                                        Actions
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenu1">
                                        <button class="dropdown-item" id="btnOrdersAddOrder" @click="onAddOrderClick">
                                            Add Order
                                        </button>
                                        <button class="dropdown-item" id="btnExportOrdersToExcel" @click="exportOrdersToExcel">
                                            Export In Excel
                                        </button>
                                        <button class="dropdown-item" id="btnScheduleOrders" @click="onScheduleOrdersClick">
                                            Schedule Orders
                                        </button>
                                        <router-link class="dropdown-item" id="btnResequenceOrders" to="/orders/delivery/resequenceDeliveryOrdersForDelivery">
                                            Resequence Orders
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <label>Customer</label>
                                        <bootstrap-select  :selectOptions="customers" :selectedOption="filter.companyId" :elementId="'customerFilterSelect'"
                                                           :returnSelectedOptionText="true"
                                                           @changeSelect="onCustomerFilterSelect"></bootstrap-select>
                                    </div>
                                    <div class="col-6" >
                                        <label>Order Status</label>
                                        <bootstrap-select  :selectOptions="orderStatuses" :selectedOption="filter.orderStatusId" :elementId="'orderStatusFilterSelect'"
                                                           :returnSelectedOptionText="true"
                                                           @changeSelect="onOrderStatusSelect"></bootstrap-select>
                                    </div>
                                </div>
                                <br>
                                <br>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <from-date-to-date-pickers  :title="'Date Created'"
                                                                    :fromDate="filter.fromDateCreated"
                                                                    :toDate="filter.toDateCreated"
                                                                    :elementId="'customerDateFilter'"
                                                                    :dateFormat="'DD/MM/YYYY'"
                                                                    @clearDatePicker="onDateFilterClearClick"
                                                                    @fromDateSelected="onFromDateCreatedSelect"
                                                                    @toDateSelected="onToDateCreatedSelect"></from-date-to-date-pickers>
                                    </div>
                                    <div class="col-sm-6 align-self-center">
                                        <div class="pr-3" v-if="showExpectedDateOfDeliveryFilter">
                                            <from-date-to-date-pickers  :title="'Expected Date of Delivery'"
                                                                        :fromDate="filter.expectedDateOfDeliveryFromDate"
                                                                        :toDate="filter.expectedDateOfDeliveryToDate"
                                                                        :elementId="'expectedDateOfDeliveryFilter'"
                                                                        :dateFormat="'DD/MM/YYYY'"
                                                                        @clearDatePicker="onExpectedDateOfDeliveryFilterClearClick"
                                                                        @fromDateSelected="onExpectedDateOfDeliveryFromDateSelect"
                                                                        @toDateSelected="onExpectedDateOfDeliveryToDateSelect"></from-date-to-date-pickers>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

<!--    <mark-as-active-inactive-modal-->
<!--                :heading="customerMarkAsActiveInactiveModal.heading"-->
<!--                :modalId="customerMarkAsActiveInactiveModal.modalId"-->
<!--                :isSaving="customerMarkAsActiveInactiveModal.isSaving"-->
<!--                :showModal="customerMarkAsActiveInactiveModal.showModal"-->
<!--                :isActive="customerMarkAsActiveInactiveModal.isActive"-->
<!--                @closeClicked="customerMarkAsActiveInactiveModal.showModal = false"-->
<!--                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>-->
    
    <select-order-type-modal
            :currentOrderTypeId="filter.orderTypeId"
            :heading="selectOrderTypeModal.heading"
            :modalId="selectOrderTypeModal.modalId"
            :showModal="selectOrderTypeModal.showModal"
            :canViewDeliveryOrders="canViewDeliveryOrders"
            :canViewCollectionOrders="canViewCollectionOrders"
            @onCancelClicked="onSelectOrderTypeModalCancelClicked"
            @placeOrder="onPlaceOrder">
    </select-order-type-modal>

    <select-shipping-address-for-order-modal
            :customer="shippingAddressSelectModal.company"
            :showModal="shippingAddressSelectModal.showModal"
            @shippingAddressSelected="onShippingAddressSelected"></select-shipping-address-for-order-modal>
    
    <create-delivery-order-modal
            :heading="orderForDeliveryModal.heading"
            :modalId="orderForDeliveryModal.modalId"
            :showModal="orderForDeliveryModal.showModal"
            :customer="orderForDeliveryModal.company"
            :shippingAddress="shippingAddressSelectedForOrder"
            @placeOrderOkClicked="onPlaceOrderForDeliveryOkClicked">
    </create-delivery-order-modal>
    
<!--    <create-collection-order-modal-->
<!--            :heading="orderForCollectionModal.heading"-->
<!--            :modalId="orderForCollectionModal.modalId"-->
<!--            :showModal="orderForCollectionModal.showModal"-->
<!--            :customer="orderForCollectionModal.company"-->
<!--            @placeOrderOkClicked="onPlaceOrderForCollectionOkClicked"></create-collection-order-modal>-->
    
    <reason-for-order-rejection-modal
        :heading="reasonForOrderCancellationModal.heading"
        :modalId="reasonForOrderCancellationModal.modalId"
        :showModal="reasonForOrderCancellationModal.showModal"
        :orderId="reasonForOrderCancellationModal.orderId"
        :orderDeliveryId="reasonForOrderCancellationModal.orderDeliveryId"
        @okButtonClicked="onReasonForCancellationOkButtonClicked"></reason-for-order-rejection-modal>
    
    <tracking-history-modal
            :heading="trackingHistoryModal.heading"
            :modalId="trackingHistoryModal.modalId"
            :showModal="trackingHistoryModal.showModal"
            :orderId="trackingHistoryModal.orderId"
            @okButtonClicked="onTrackingHistoryOkButtonClicked"></tracking-history-modal>

    <order-audit-modal
            :heading="orderAuditModal.heading"
            :modalId="orderAuditModal.modalId"
            :showModal="orderAuditModal.showModal"
            :orderId="orderAuditModal.orderId"
            @okButtonClicked="onOrderAuditOkButtonClicked"></order-audit-modal>
    
    <modal-message
        :heading="'No Delivery Batch'"
        :elementId="'noBatchMessageModal'"
        :message="noDeliveryBatchModal.message"
        :showModal="noDeliveryBatchModal.showModal"
        @okClicked="onNoDeliveryBatchOkClick"></modal-message>

    <order-documents-modal
            :orderId="documentsModal.orderId"
            :heading="documentsModal.heading"
            :modalId="documentsModal.modalId"
            :showModal="documentsModal.showModal"
            :orderTypeId="documentsModal.orderTypeId"
            :orderStatusId="documentsModal.orderStatusId"
            @closeModal="onDocumentsModalClose"></order-documents-modal>
</div>
